import { useEffect, useRef } from 'react';

import type { ListPageController } from '../model/useListPageController';
import { encodeUserState } from './payload';
import type { ListPageServerState } from './useListPageServerState';

/**
 * Debounced persistence per-uživatel stavu (anatomie 05 §6): konfigurace sloupců, pořadí
 * záložek, naposledy aktivní pohled a preference (velikost stránky, Živě, panel filtrů).
 * První render (aplikace načteného stavu) se přeskakuje — nezapisuje se, co se právě načetlo.
 */
export function usePersistUserState<TItem>({
  controller,
  server,
}: {
  controller: ListPageController<TItem>;
  server: ListPageServerState;
}) {
  const skipFirst = useRef(true);

  useEffect(() => {
    if (skipFirst.current) {
      skipFirst.current = false;
      return;
    }
    server.saveUserState(
      encodeUserState({
        viewOrder: controller.viewOrder,
        lastActiveViewId: controller.activeViewId,
        widthMode: controller.widthMode,
        columnStates: controller.columnStates,
        prefs: {
          pageSize: controller.pageSize,
          live: controller.live,
          panelOpen: controller.panelOpen,
          panelWidth: controller.panelWidth,
          stats: controller.statsOpen,
        },
      })
    );
  }, [
    server,
    controller.viewOrder,
    controller.activeViewId,
    controller.widthMode,
    controller.columnStates,
    controller.pageSize,
    controller.live,
    controller.panelOpen,
    controller.panelWidth,
    controller.statsOpen,
  ]);
}
